<template>
  <el-dialog class="user-dialog" v-bind="$attrs" v-on="$listeners">
    <div class="el-dialog-body-child">
      <el-form ref="queryForm" :model="queryParams" label-width="80px" :inline="true" class="search-form clearfix">
        <el-form-item class="search-field inventory-entry fl" label="商品名称" prop="goodsName">
          <el-input v-model.trim="queryParams.goodsName" placeholder="请输入商品名称" clearable
            @keyup.enter.native="handleQuery" />
        </el-form-item>
        <el-form-item class="search-field inventory-entry fl" label="单品编号" prop="spuSn">
          <el-input v-model.trim="queryParams.spuSn" placeholder="请输入单品编号" clearable
            @keyup.enter.native="handleQuery" />
        </el-form-item>
        <div class="fr">
          <el-button plain @click="resetQuery">重 置</el-button>
          <el-button type="primary" @click="handleQuery">查 询</el-button>
        </div>
      </el-form>
      <div class="table-wrap">
        <div class="tips-box">
          <el-tag type="warning">温馨提示：重新搜索后，需重新勾选并点击保存方可见效。</el-tag><el-button class="search-all-selected"
            type="primary" :disabled="isQueryAllSelected" @click="handleSearchAllSelected"
            size="small">点击查看已选择的商品</el-button>
        </div>
        <div class="table-box">
          <auto-height-table instanceHeight="338" ref="spuTable" :class="{ 'empty': list.length === 0 }" empty-text=" "
            v-loading="loading" :data="list" row-key="spuId" @selection-change="handleSelectionChange"
            @row-click="clickRow">
            <el-table-column type="selection" :reserve-selection="true" width="55" align="center" />
            <el-table-column label="商品信息" prop="goodsName" align="left" min-width="168px">
              <template slot-scope="scope">
                <div class="goods-info flex-c-s">
                  <div class="goods-info-left">
                    <img @click.stop="mixinHandlePreview(scope.row.goodsImgs && scope.row.goodsImgs.split(','))"
                      :src="mixinGetImg(scope.row.goodsImgs && scope.row.goodsImgs.split(',')[0])" width="40px" height="40px"
                      alt="商品图片">
                  </div>
                  <div class="goods-info-right flex-c-c flex-col">
                    <div class="top">
                      <span class="label">名称：</span>
                      <span class="value">{{ scope.row.goodsName }}</span>
                    </div>
                    <div class="bottom">
                      <span class="label">编号：</span>
                      <span class="value">{{ scope.row.goodsSn }}</span>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="规格信息" prop="skuListStr" align="left" min-width="168px">
              <template slot-scope="scope">
                <div class="goods-info-right flex-c-c flex-col">
                  <div class="top">
                    <span class="label">规格：</span>
                    <span class="value">{{ scope.row.skuListStr }}</span>
                  </div>
                  <div class="bottom">
                    <span class="label">编号：</span>
                    <span class="value">{{ scope.row.spuSn }}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="成本单价(元)" prop="costPrice" align="center" />
          </auto-height-table>
          <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize" @pagination="getList" />
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <template>
        <el-button @click="close">关 闭</el-button>
        <el-button type="primary" @click="save">选 择</el-button>
      </template>
    </div>
  </el-dialog>
</template>
<script>
import { spuApi } from "@/api"
export default {
  props: {
    // 已选择的id
    selectIdArr: {
      type: [Array],
      default: () => {
        return []
      }
    }
  },
  watch: {
    selectIdArr(val) {
      if (val && val.length > 0) {
        this.isQueryAllSelected = false
        this.spuIds = this.selectIdArr
        // 渲染选中表格
        this.renderSelectTable()
      } else {
        // 解决编辑入库单成功后再次新增 入库单 点击 新增商品 会默认 选中上次新增的 商品的问题
        this.clearSelection()
      }
    }
  },
  data() {
    return {
      isQueryAllSelected: false, // 是否已点击查询所有已分配
      //搜索条件参数
      queryParams: {
        goodsName: "", // 品牌名称
        spuSn: "", // 单品编号
        spuIds: "", // 品牌id
        publishStatus: "1", // 只查启用的
        pageNum: 1,
        pageSize: 10
      },
      loading: false,
      list: [],
      total: 0,
      ids: [], // 已选中的项
      spuIds: [], // 已分配的品牌id列表
      isRenderPage: [], // 已渲染过的列表页码
      listSelectIds: [] // 已渲染过的用户id数据
    }
  },
  created() {
    //获取列表
    this.getList()
  },
  methods: {
    close() {
      this.$emit("close")
    },
    // 查询所有已分配的角色
    handleSearchAllSelected() {
      if (this.isQueryAllSelected) { return }
      this.isQueryAllSelected = true // 是否查询已分配
      if (this.spuIds.length === 0) {
        this.$modal.msgWarning("暂未添加任何入库单品，请选择")
        return
      }
      this.queryParams.spuIds = this.spuIds.join(",")
      this.mixinResetForm("queryForm")
      this.handleQuery({ isSearchAllSelected: true })
    },
    // 清空选项
    clearSelection(isSearch) {
      this.$refs.spuTable && this.$refs.spuTable.clearSelection()
      this.isRenderPage = []
      this.listSelectIds = []
      this.ids = []
      if (isSearch) {
        return
      }
      this.mixinResetForm("queryForm")
      this.queryParams.pageNum = 1
      this.queryParams.spuIds = ""
      this.spuIds = []
      this.getList()
    },
    // 渲染选中的数据
    renderSelectTable() {
      if (
        this.isRenderPage.includes(this.queryParams.pageNum) ||
        this.spuIds.length === 0
      ) {
        return
      }
      this.isRenderPage.push(this.queryParams.pageNum)
      for (let i = 0; i < this.list.length; i++) {
        const item = this.list[i]
        if (this.spuIds.includes(item.spuId)) {
          this.listSelectIds.push(item.spuId)
          this.$nextTick(() => {
            this.$refs.spuTable && this.$refs.spuTable.toggleRowSelection(item, true)
          })
        }
      }
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.spuId)
    },
    //点击行
    clickRow(row) {
      this.$refs.spuTable && this.$refs.spuTable.toggleRowSelection(row)
    },
    /** 搜索按钮操作 data.isSearchAllSelected 是否是查询全部已选列表 不是的话 把搜索条件的brandIds 设置为  "" */
    handleQuery(data) {
      if (!data || !data.isSearchAllSelected) {
        this.isQueryAllSelected = false
        this.queryParams.spuIds = ""
      }
      // 点击搜索时 清空选项 重新开始
      this.clearSelection(true)
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.isQueryAllSelected = false
      this.mixinResetForm("queryForm")
      this.handleQuery()
    },
    /** 查询列表 */
    getList(options) {
      if (options?.type === "sizeChange") {
        this.isRenderPage = []
      }
      this.loading = true
      spuApi
        .getList(this.queryParams)
        .then((response) => {
          this.list = response.rows
          this.total = response.total
          this.loading = false
          this.renderSelectTable()
        })
        .catch((err) => {
          if (err?.name === "CanceledError") {
            return
          }
          this.loading = false
        })
    },
    // 保存
    async save() {
      if (this.ids.length === 0) {
        this.$modal.msgWarning("请选择商品")
        return
      }
      // 获取已选中ids没有，listSelectIds有的userId：说明这些用户被移除勾选了
      const removeIds = [...new Set(this.listSelectIds)].filter(
        (item) => !new Set(this.ids).has(item)
      )
      // 获取已选中ids有，listSelectIds没有的userId： 说明这些是新增的
      const addIds = [...new Set(this.ids)].filter(
        (item) => !new Set(this.listSelectIds).has(item)
      )
      // 利用最先的userIds 去除移除勾选的 添加新增的
      let resultIds = []
      // 去掉移除勾选的
      resultIds = [...new Set(this.spuIds)].filter(
        (item) => !new Set(removeIds).has(item)
      )
      // 添加新增的
      resultIds = resultIds.concat(addIds)
      const data = await spuApi.findAll({ spuIds: resultIds.join(",") })
      this.$emit("success", data, removeIds)
    }
  }
}
</script>
<style lang="scss" scoped></style>
